import {useEffect} from 'react';

import {useSelector} from 'react-redux';

import {getIsOrderHasActiveSubscriptionCL} from 'desktop/pages/checkout/store/selectors/orderReviewItems/orderReviewItems';
import {useGetCustomerData} from 'hooks/getCustomerData/getCustomerData';
import {useHostDispatch} from 'hooks/hostHooks/hostHooks';

import {useHasGlassesCare} from '../useHasGlassesCare/useHasGlassesCare';

/**
 * Hook is responsible for force registration in some cases
 */
export const useForceRegistration = () => {
    const customer = useGetCustomerData();
    const isCartHasActiveSubscriptionCL = useSelector(getIsOrderHasActiveSubscriptionCL);
    const dispatch = useHostDispatch();

    const isLoggedIn = customer.is_logged_in;
    const isAuthPending = customer.status?.toLowerCase() === 'pending';

    const hasGlassesCare = useHasGlassesCare();

    const messageForLoginPopup = isCartHasActiveSubscriptionCL
        ? 'Easily manage your subscription details.'
        : 'Enjoy access to your saved prescriptions, addresses and order tracking.';
    const isForcedBySubscription =
        (isCartHasActiveSubscriptionCL && !isLoggedIn && !isAuthPending) ||
        (hasGlassesCare && !isLoggedIn);

    useEffect(() => {
        if (isForcedBySubscription) {
            dispatch({
                payload: true,
                type: 'AUTH_POPUP@SET_IS_FORCED_SIGN_UP',
            });
            dispatch({
                payload: {
                    tab: 'signUp',
                    visible: true,
                },
                type: 'AUTH_POPUP@SET_VISIBLE',
            });
            dispatch({
                payload: messageForLoginPopup,
                type: 'AUTH_POPUP@SET_USEFUL_MESSAGE',
            });
        }
    }, [dispatch, isForcedBySubscription, messageForLoginPopup]);
};
